export const EMPTY_EVENT = {
  event_title: "",
  event_description: "",
  event_start_date: "",
  event_end_date: "",
};

export const EMPTY_SCHEDULE = {
  event_schedule_title: "",
  event_schedule_date: "",
  event_schedule_time: "",
};

// Render order of the event form. Change the order here to change the layout.
// minFrom / maxFrom: another field whose value limits the date picker.
export const EVENT_FIELDS = [
  { name: "event_title", label: "Title", required: true },
  { name: "event_description", label: "Description", required: true, multiline: true },
  {
    name: "event_start_date",
    label: "Start Date",
    type: "date",
    required: true,
    // no maxFrom: the user may pick a start date after the end date; the end date is then cleared
  },
  {
    name: "event_end_date",
    label: "End Date",
    type: "date",
    required: true,
    minFrom: "event_start_date",
  },
];

// Every schedule row uses these columns. All of them are required.
export const SCHEDULE_FIELDS = [
  { name: "event_schedule_title", label: "Title", type: "text", accessor: "title", width: "25%" },
  { name: "event_schedule_date", label: "Date", type: "date", accessor: "date", width: "20%" },
  { name: "event_schedule_time", label: "Time", type: "time", accessor: "time", width: "20%" },
];

// "yyyy-mm-dd" + days -> "yyyy-mm-dd" (local date maths, so no timezone shift)
export const addDays = (isoDate, days) => {
  const [y, m, d] = isoDate.split("-").map(Number);
  const next = new Date(y, m - 1, d + days);
  const pad = (n) => String(n).padStart(2, "0");
  return `${next.getFullYear()}-${pad(next.getMonth() + 1)}-${pad(next.getDate())}`;
};

const isBlank = (value) => value === undefined || value === null || String(value).trim() === "";

// Real validation state: used to enable / disable the submit button
export const getEventFieldError = ({ name, label, required }, eventData) => {
  const value = eventData[name];

  if (required && isBlank(value)) {
    return `${label} is required`;
  }

  if (name === "event_end_date" && !isBlank(value) && value < eventData.event_start_date) {
    return "End date cannot be before start date";
  }

  return "";
};

export const getScheduleFieldError = ({ name, label }, row, eventData) => {
  const value = row[name];

  if (isBlank(value)) {
    return `${label} is required`;
  }

  if (name === "event_schedule_date") {
    const { event_start_date: start, event_end_date: end } = eventData;
    if ((start && value < start) || (end && value > end)) {
      return "Date must be within the event dates";
    }
  }

  return "";
};

// Schedules are kept in state as date "yyyy-mm-dd" and time "HH:mm",
// so the date and time inputs never depend on each other's format.
export const normalizeSchedule = (item) => ({
  ...item,
  event_schedule_title: item.event_schedule_title || "",
  event_schedule_date: item.event_schedule_date?.slice(0, 10) || "",
  event_schedule_time: item.event_schedule_time?.slice(11, 16) || "",
});

// Converts the state format back into the "yyyy-mm-dd hh:mm:ss" strings the API expects
export const buildEventPayload = (eventData, scheduleData) => ({
  ...eventData,
  schedule: scheduleData.map((item) => ({
    ...item,
    event_schedule_date: `${item.event_schedule_date} 00:00:00`,
    event_schedule_time: `${item.event_schedule_date} ${item.event_schedule_time}:00`,
  })),
});

export const buildMediaFormData = (eventId, newFiles) => {
  const formData = new FormData();
  formData.append("event_id", eventId);
  newFiles.forEach((item) => formData.append("files", item.file));
  return formData;
};
